// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1DDAq","content":"ManualTimeModal_content__1QV7X"};